import {getModuleSpecs, readModuleSpecs, install} from '@malt/hopmodules';

function mixin(Hop) {
    install(Hop);
}

export {
    getModuleSpecs,
    readModuleSpecs,
    mixin,
};
